import React, { useState, useRef, useEffect, useContext } from 'react';
import styled, { ThemeContext } from 'styled-components/macro';
import ReactDOM from 'react-dom';
import { useTranslate } from '../contexts/languageContext';
import LoadingBar from 'react-top-loading-bar';

/**
 *  Componente que muestra un aviso de carga si la página tarda en cargar más de una
 * cantidad determinada, dando al usuario feedback de que sus acciones están siendo procesadas
 * por la página
 */

const Spinner = ({ loading, delay = 1000, ...rest }) => {
  const spinnerDebounce = useDebounce(loading, delay);
  const loadingRef = useRef();
  const theme = useContext(ThemeContext);
  const color = theme.colorBarra;

  useEffect(() => {
    loading && spinnerDebounce && loadingRef.current.continuousStart();
    spinnerDebounce && !loading && loadingRef.current.complete();
  }, [loading, spinnerDebounce]);
  return ReactDOM.createPortal(
    <Container {...rest}>
      {(loading || spinnerDebounce) && (
        <LoadingBar onRef={ref => (loadingRef.current = ref)} color={color} />
      )}
    </Container>,
    document.getElementById('root')
  );
};
export default Spinner;

const Container = styled.div`
  position: absolute;
  width: 100%;
  box-sizing: border-box
  top: 0;
  left: 0;
`;

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
